export default __webpack_public_path__ + "static/stacked-area-43b6c5174706141edd1c3028961f4f9f.png";